<template>
    <NuxtLayout name="malt-base-layout">
        <HeaderUnlogged v-if="showNewUnloggedNavbar" />
        <Navbar v-else show-search-unlogged />
        <div
            class="search-app"
            :class="{
                'search-app--logged': loggedIn,
                'search-app--with-search-banner': !loggedIn && showNewUnloggedNavbar,
            }"
        >
            <slot />
        </div>
        <Footer />
        <ClientOnboarding />
    </NuxtLayout>
</template>
<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {Footer, Navbar, ClientOnboarding, HeaderUnlogged} from '#components';
    import {useAuth, useNewUnloggedNavbar} from '#imports';

    const {loggedIn} = storeToRefs(useAuth());
    const {showNewUnloggedNavbar} = useNewUnloggedNavbar();
</script>
<style scoped lang="scss">
    .search-app {
        position: relative;
        top: var(--search-banner-unlogged-height, 0);

        --search-page-header-height: calc(var(--header-height) + var(--search-banner-unlogged-height, 0px));

        &--logged {
            top: 0;

            --search-page-header-height: var(--layout-padding-top);
        }

        &--with-search-banner {
            --search-banner-unlogged-height: 0px;
        }
    }
</style>
